import CodeBlock from "../../common/code_block";
import ErrorCodesLink from "../../common/ErrorCodesLink";
import EnvelopeRows from "../../common/EnvelopeRows";
import HeaderWithTag from "../../common/header_with_tag";
import TryGetBalance from "./try";
import { Link } from 'react-router-dom';
import { HOST_API_URL } from "../../config";

const responseCode = `{
  "statusCode": 200,
  "message": "Success",
  "errorCode": null,
  "data": {
    "balance": 711427.4208
  }
}`;

const failureResponseCode = `{
  "statusCode": 400,
  "message": "Invalid input",
  "errorCode": "DPI-6001",
  "data": null
}`;

function GetBalance() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Get Balance</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Get Balance
                  </li>
                </ol>
              </div>
            </div>

            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-7" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">
                      <HeaderWithTag
                        headerText="Retrieve account balance"
                        headerTag="description"
                      />
                      <p className="text-12">
                        <span className="badge badge-sm bg-blue text-white me-2">
                          GET
                        </span>
                        {HOST_API_URL}/Remittances/GetBalance
                      </p>
                      <p className="text-muted text-14" style={{ textAlign: "justify" }}>
                        Returns the current account balance for the authenticated user.
                        This endpoint provides real-time balance information for your remittance account.
                      </p>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Authentication"
                          headerTag="auth"
                        />
                        <p className="text-muted text-14">
                          This endpoint requires authentication. You must include a valid Bearer token in the Authorization header.
                        </p>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Response"
                          headerTag="response"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Parameters</th>
                                <th>Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <EnvelopeRows />
                              <tr>
                                <td>data.balance</td>
                                <td>number</td>
                                <td>
                                  Current account balance, to 4 decimal places. Never
                                  negative &mdash; a negative computed balance is returned
                                  as 0.
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={responseCode}
                          codeBlackText="Response Example"
                          codeLanguage="json"
                        />
                      </div>

                      <div className="my-5">
                        <CodeBlock
                          code={failureResponseCode}
                          codeBlackText="Failure Example"
                          codeLanguage="json"
                        />
                      </div>

                      <ErrorCodesLink />
                    </div>
                  </div>
                </div>
                <div className="col-md-5 pt-5">
                  <h5 className="card-title text-primary">
                     Code Samples
                  </h5>

                  <TryGetBalance
                    codeBlackTitle="Request Simple"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetBalance;